import React, { useEffect } from "react";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import theme from "./theme";
import '../src/App.css';
// Pages
import Home from "./pages/Home";
import Categories from "./pages/Categories";
import CategorySongs from "./pages/CategorySongs";
import Favorites from "./pages/Favorites";
import Playlists from "./pages/Playlists";
import Search from "./pages/Search";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Layout from "./components/Layout";
import Player from "./pages/Player";
import Cookies from "js-cookie";
import { MusicProvider } from "./context/MusicContext";
import { useNavigate } from "react-router-dom";

function App() {
  const navigate = useNavigate();
  useEffect(()=> {
 
    
    

     if(localStorage.getItem("FAV") === null){
         localStorage.setItem("FAV","");
     }


     if (Cookies.get("User") == "" || Cookies.get("User") == null) {
      navigate("/login");
    }
  },[]);

  return (
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode="system" />
      <MusicProvider>
        <Routes>
          <Route path="/player" element={<Player />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/*"
            element={
              <Layout>
                <AnimatePresence mode="wait">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/category/:id" element={<CategorySongs />} />
                    <Route path="/favorites" element={<Favorites />} />
                    <Route path="/playlists" element={<Playlists />} />
                    <Route path="/search" element={<Search />} />
                  </Routes>
                </AnimatePresence>
              </Layout>
            }
          />
        </Routes>
      </MusicProvider>
    </ChakraProvider>
  );
}

export default App;
